if (!window.CEARequireSizeSelectionLoaded) {
  window.CEARequireSizeSelectionLoaded = true;

  (() => {
    const PICKER_SELECTOR =
      'variant-picker[data-main-product="true"]';

    const SIZE_WRAPPER_SELECTOR =
      '.variant-picker__product-option[data-size-option="true"]';

    const ADD_TO_CART_SELECTOR = [
      'form[action*="/cart/add"] button[type="submit"]',
      '.product-form__btn-add-to-cart',
      '.block-add-to-cart__button'
    ].join(',');

    const DYNAMIC_CHECKOUT_SELECTOR =
      '.product-form__dynamic-checkout, .shopify-payment-button';

    const STYLE_ID = 'cea-require-size-selection-styles';

    function addStyles() {
      if (document.getElementById(STYLE_ID)) return;

      const style = document.createElement('style');

      style.id = STYLE_ID;
      style.textContent = `
        /*
         * Swift keeps its default variant internally, but while this
         * class is present the customer does not see a selected size.
         */
        variant-picker.cea-size-choice-pending
          ${SIZE_WRAPPER_SELECTOR}
          .variant-option.selected + label,
        variant-picker.cea-size-choice-pending
          ${SIZE_WRAPPER_SELECTOR}
          .variant-option:checked + label,
        variant-picker.cea-size-choice-pending
          ${SIZE_WRAPPER_SELECTOR}
          input.selected + label,
        variant-picker.cea-size-choice-pending
          ${SIZE_WRAPPER_SELECTOR}
          input:checked + label {
          background: transparent !important;
          background-color: transparent !important;
          color: inherit !important;
          border-color: rgba(var(--color-line-and-border)) !important;
          box-shadow: none !important;
          outline: none !important;
        }

        variant-picker.cea-size-choice-pending
          ${SIZE_WRAPPER_SELECTOR}
          .variant-option.selected + label::before,
        variant-picker.cea-size-choice-pending
          ${SIZE_WRAPPER_SELECTOR}
          .variant-option.selected + label::after,
        variant-picker.cea-size-choice-pending
          ${SIZE_WRAPPER_SELECTOR}
          .variant-option:checked + label::before,
        variant-picker.cea-size-choice-pending
          ${SIZE_WRAPPER_SELECTOR}
          .variant-option:checked + label::after,
        variant-picker.cea-size-choice-pending
          ${SIZE_WRAPPER_SELECTOR}
          input:checked + label::before,
        variant-picker.cea-size-choice-pending
          ${SIZE_WRAPPER_SELECTOR}
          input:checked + label::after {
          opacity: 0 !important;
          box-shadow: none !important;
        }

        /*
         * The controls remain functionally gated, but they are no
         * longer faded while waiting for a size selection.
         */
        .cea-size-gated-control {
          position: relative !important;
        }

        /*
         * Keep the Add to Cart button at its normal full-strength red
         * and temporarily display "Choose Size."
         */
        .cea-size-gated-button {
          position: relative !important;
          background: #C94444 !important;
          background-color: #C94444 !important;
          border-color: #C94444 !important;
          color: transparent !important;
          opacity: 1 !important;
        }

        /*
         * Hide Swift's original button contents without deleting them.
         * They become visible again when this class is removed.
         */
        .cea-size-gated-button
          > *:not(.cea-size-button-label):not(.cea-size-gate-overlay) {
          visibility: hidden !important;
        }

        .cea-size-button-label {
          position: absolute;
          inset: 0;
          z-index: 40;
          display: flex;
          align-items: center;
          justify-content: center;
          width: 100%;
          height: 100%;
          padding: inherit;
          color: #FFFFFF !important;
          font: inherit;
          font-weight: inherit;
          line-height: inherit;
          letter-spacing: inherit;
          text-align: center;
          pointer-events: none;
          visibility: visible !important;
        }

        .cea-size-gate-overlay {
          position: absolute;
          inset: 0;
          z-index: 50;
          display: block;
          cursor: pointer;
          background: transparent;
          border: 0;
          margin: 0;
          padding: 0;
        }

        .cea-size-choice-required {
          color: #C94444 !important;
        }

        ${SIZE_WRAPPER_SELECTOR}.cea-size-choice-attention {
          animation: cea-size-choice-pulse 0.7s ease-in-out 2;
        }

        @keyframes cea-size-choice-pulse {
          0%,
          100% {
            opacity: 1;
          }

          50% {
            opacity: 0.5;
          }
        }
      `;

      document.head.appendChild(style);
    }

    function getSectionWrapper(picker) {
      const sectionId = picker.dataset.sectionId;

      return (
        document.getElementById(`shopify-section-${sectionId}`) ||
        picker.closest('.shopify-section') ||
        document
      );
    }

    function getSizePosition(sizeWrapper) {
      const sizeOption = sizeWrapper.querySelector(
        '.variant-option[data-option-position]'
      );

      return sizeOption?.dataset.optionPosition || '';
    }

    function findClickedOption(event, picker) {
      const directOption = event.target.closest?.(
        '.variant-option[data-option-position]'
      );

      if (directOption && picker.contains(directOption)) {
        return directOption;
      }

      const label = event.target.closest?.('label[for]');

      if (!label || !picker.contains(label)) {
        return null;
      }

      const inputId = label.getAttribute('for');

      if (!inputId) return null;

      try {
        return picker.querySelector(
          `#${CSS.escape(inputId)}`
        );
      } catch (error) {
        return null;
      }
    }

    function initializePicker(picker) {
      if (picker.dataset.ceaSizeGateInitialized === 'true') {
        return;
      }

      const sizeWrapper = picker.querySelector(
        SIZE_WRAPPER_SELECTOR
      );

      if (!sizeWrapper) return;

      const sizePosition = getSizePosition(sizeWrapper);

      if (!sizePosition) return;

      picker.dataset.ceaSizeGateInitialized = 'true';
      picker.dataset.ceaSizeChosen = 'false';
      picker.classList.add('cea-size-choice-pending');

      const sectionWrapper = getSectionWrapper(picker);

      function sizeHasBeenChosen() {
        return picker.dataset.ceaSizeChosen === 'true';
      }

      function getSelectedValueLabel() {
        return picker.querySelector(
          `.variant-option__selected-value[data-position="${sizePosition}"]`
        );
      }

      function showPlaceholder() {
        if (sizeHasBeenChosen()) return;

        const selectedValueLabel = getSelectedValueLabel();

        if (selectedValueLabel) {
          selectedValueLabel.textContent = 'Choose a size';
        }
      }

      function promptForSize() {
        if (sizeHasBeenChosen()) return;

        const selectedValueLabel = getSelectedValueLabel();

        if (selectedValueLabel) {
          selectedValueLabel.textContent =
            'Please choose a size';

          selectedValueLabel.classList.add(
            'cea-size-choice-required'
          );
        }

        sizeWrapper.scrollIntoView({
          behavior: 'smooth',
          block: 'center'
        });

        sizeWrapper.classList.remove(
          'cea-size-choice-attention'
        );

        void sizeWrapper.offsetWidth;

        sizeWrapper.classList.add(
          'cea-size-choice-attention'
        );

        window.clearTimeout(
          picker.ceaSizePromptTimer
        );

        picker.ceaSizePromptTimer = window.setTimeout(() => {
          if (sizeHasBeenChosen()) return;

          const currentLabel = getSelectedValueLabel();

          if (currentLabel) {
            currentLabel.textContent = 'Choose a size';
            currentLabel.classList.remove(
              'cea-size-choice-required'
            );
          }

          sizeWrapper.classList.remove(
            'cea-size-choice-attention'
          );
        }, 2200);
      }

      function addChooseSizeLabel(control) {
        if (
          !control.matches?.(ADD_TO_CART_SELECTOR) ||
          control.querySelector(
            ':scope > .cea-size-button-label'
          )
        ) {
          return;
        }

        control.classList.add('cea-size-gated-button');

        const label = document.createElement('span');

        label.className = 'cea-size-button-label';
        label.textContent = 'Choose Size';
        label.setAttribute('aria-hidden', 'true');

        control.appendChild(label);
      }

      function addGateOverlay(control) {
        if (!control) return;

        control.classList.add('cea-size-gated-control');

        addChooseSizeLabel(control);

        if (
          control.querySelector(
            ':scope > .cea-size-gate-overlay'
          )
        ) {
          return;
        }

        const overlay = document.createElement('span');

        overlay.className = 'cea-size-gate-overlay';
        overlay.setAttribute('aria-hidden', 'true');

        overlay.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();
          event.stopImmediatePropagation();

          promptForSize();
        });

        overlay.addEventListener('pointerdown', (event) => {
          event.preventDefault();
          event.stopPropagation();
        });

        control.appendChild(overlay);
      }

      function addGateOverlays() {
        if (sizeHasBeenChosen()) return;

        sectionWrapper
          .querySelectorAll(ADD_TO_CART_SELECTOR)
          .forEach(addGateOverlay);

        sectionWrapper
          .querySelectorAll(DYNAMIC_CHECKOUT_SELECTOR)
          .forEach(addGateOverlay);
      }

      function removeGateOverlays() {
        sectionWrapper
          .querySelectorAll('.cea-size-gate-overlay')
          .forEach((overlay) => overlay.remove());

        sectionWrapper
          .querySelectorAll('.cea-size-button-label')
          .forEach((label) => label.remove());

        sectionWrapper
          .querySelectorAll('.cea-size-gated-button')
          .forEach((button) => {
            button.classList.remove(
              'cea-size-gated-button'
            );
          });

        sectionWrapper
          .querySelectorAll('.cea-size-gated-control')
          .forEach((control) => {
            control.classList.remove(
              'cea-size-gated-control'
            );
          });
      }

      function applyPendingState() {
        if (sizeHasBeenChosen()) return;

        picker.classList.add('cea-size-choice-pending');

        showPlaceholder();
        addGateOverlays();
      }

      function releaseSizeGate() {
        if (sizeHasBeenChosen()) return;

        picker.dataset.ceaSizeChosen = 'true';
        picker.classList.remove('cea-size-choice-pending');

        window.clearTimeout(
          picker.ceaSizePromptTimer
        );

        const selectedValueLabel = getSelectedValueLabel();

        if (selectedValueLabel) {
          selectedValueLabel.classList.remove(
            'cea-size-choice-required'
          );
        }

        sizeWrapper.classList.remove(
          'cea-size-choice-attention'
        );

        removeGateOverlays();
        observer.disconnect();
      }

      /*
       * Capture the size click before Swift processes it. We only
       * remove our visual gate; the original click continues normally.
       */
      picker.addEventListener(
        'click',
        (event) => {
          if (sizeHasBeenChosen()) return;

          const option = findClickedOption(event, picker);

          if (
            option &&
            option.dataset.optionPosition === sizePosition
          ) {
            releaseSizeGate();
          }
        },
        true
      );

      /*
       * Swift may redraw parts of the product form after another
       * option changes, so restore the placeholder and gate.
       */
      const observer = new MutationObserver(() => {
        if (sizeHasBeenChosen()) return;

        window.requestAnimationFrame(
          applyPendingState
        );
      });

      observer.observe(sectionWrapper, {
        subtree: true,
        childList: true
      });

      applyPendingState();

      window.requestAnimationFrame(() => {
        applyPendingState();

        window.requestAnimationFrame(
          applyPendingState
        );
      });
    }

    function initializeAllPickers(root = document) {
      if (
        root instanceof Element &&
        root.matches(PICKER_SELECTOR)
      ) {
        initializePicker(root);
      }

      root
        .querySelectorAll?.(PICKER_SELECTOR)
        .forEach(initializePicker);
    }

    addStyles();

    if (document.readyState === 'loading') {
      document.addEventListener(
        'DOMContentLoaded',
        () => initializeAllPickers(),
        { once: true }
      );
    } else {
      initializeAllPickers();
    }

    document.addEventListener(
      'shopify:section:load',
      (event) => {
        initializeAllPickers(event.target);
      }
    );

    const pageObserver = new MutationObserver(
      (mutations) => {
        for (const mutation of mutations) {
          for (const node of mutation.addedNodes) {
            if (!(node instanceof Element)) continue;

            initializeAllPickers(node);
          }
        }
      }
    );

    pageObserver.observe(document.documentElement, {
      subtree: true,
      childList: true
    });
  })();
}